const headerDe = {
	brand: 'Grameen Bazar',
	top: {
		bazarList: 'Bazare',
		help: 'Hilfe',
		contact: 'Kontakt',
	},
	nav: {
		dailyBazar: 'Lebensmittel',
		medicineBazar: 'Medizin',
		foodBazar: 'Frischwaren',
		grains: 'Getreide',
		nationalBazar: 'National',
		garmentsBazar: 'Bekleidung',
		cosmeticsBazar: 'Kosmetik',
		bookBazar: 'Bücher',
		nurseryBazar: 'Gärtnerei',
		electronicsBazar: 'Elektronik',
		chemicalBazar: 'Chemie',
		hardwareBazar: 'Baumarkt',
		serviceBazar: 'Dienstleistungen',
		feedBazar: 'Tierfutter',
	},
	search: {
		placeholder: 'Wonach möchten Sie einkaufen?'
	},
	drawer: {
		home: 'Startseite',
		dailyBazar: 'Daily Bazar',
		medicineBazar: 'Medicine Bazar',
		grains: 'Grains Bazar',
		nationalBazar: 'National Bazar',
		foodBazar: 'Frischwaren',
		bookBazar: 'Book Bazar',
		nurseryBazar: 'Nursery Bazar',
		garmentsBazar: 'Garments Bazar',
		electronicsBazar: 'Electronics Bazar',
		chemicalBazar: 'Chemical Bazar',
		hardwareBazar: 'Hardware Bazar',
		cosmeticsBazar: 'Cosmetics Bazar',
		serviceBazar: 'Service Bazar',
		feedBazar: 'Feed Bazar',
	},
	profileMenu: {
		login: 'Anmelden',
		register: 'Registrieren',
		myAccount: 'Mein Konto',
		storeDashboard: 'Store-Dashboard',
		adminDashboard: 'Admin-Dashboard',
	},
};

export default headerDe;


